import axios from 'axios';
import {VERSION_APP} from './version';

const api = axios.create({
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
    AppSchema: VERSION_APP
  }
});

const apiUpload = axios.create({
  timeout: 100000,
  headers: {
    'Content-Type': 'multipart/form-data',
    AppSchema: VERSION_APP
  }
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    const compCode = localStorage.getItem('compCode') ?? 1;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.CompCode = compCode;
      config.headers.AppSchema = VERSION_APP;
    }
    return config;
  },
  error => Promise.reject(error)
);

export  {api, apiUpload};
